module.exports = "/_next/static/images/LaunchIntegration@2x-9d6824ca79a6bc4fe10eaa1d44ba0335.webp";